<template>
    <div
        class="button-wrapper"
        :style="style"
        @click="btnAction"
        v-loading.small="loading"
    >
        <!-- <Wait
            v-if="loading"
            :stretchSizeValue="10"
        /> -->
        <div :data-voicetext="bText">{{ bText }}</div>
    </div>

</template>

<script>
// import Wait from '../../Wait';

export default {
    name: 'ActionButton',
    props:{
        bColor: String,
        bTColor: String,
        bText: String,
        loading: {
            default: false,
            type: Boolean,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        style({bColor, bTColor, disabled}) {
            if (disabled) {
                return `background-color: #D3D3D3; color: ${bTColor}; cursor: default`;
            }
            return `background-color: ${bColor}; color: ${bTColor}`;
        },
    },
    // components: {
    //     Wait,
    // },
    methods: {
        btnAction() {
            if (!this.loading && !this.$props.disabled) {
                this.$emit('b-action');
            }
        },
    },
};
</script>

<style lang="scss" scoped>
    @import '../../../styles/rem';
    @import '../../../styles/mrem';
    /*activate checkbox regExp in finder of phpStorm*/
    /*find      {: ([0-9]*)px}*/
    /*replace   {: rem($1);}*/

    .button-wrapper{
        border-radius: rem(10);
        width: 100%;
        height: rem(48);
        position: relative;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        font-size: 0.8rem;
        cursor: pointer;
    }

    @import "../../../styles/variables";

    @media (max-width: $vm) {
      .button-wrapper{
         height: mrem(40);
         border-radius: mrem(10);
         font-size: mrem(14);
         font-weight: 600;
         line-height: mrem(17);
      }
    }
</style>
